import { createApi } from '@reduxjs/toolkit/query/react';

import { apiWeeklyPlanner } from '~constants/api';

import { Response, rtkBaseQueryWrapper, unwrap } from '~libs/axiosWrapper';
import { PublishEstimates } from '~weekly-planner/lib/common';

export const typePrefix = 'weekly-planner';

export const publishApi = createApi({
  reducerPath: 'weeklyPlannerPublishApi',
  baseQuery: rtkBaseQueryWrapper({ baseUrl: apiWeeklyPlanner }),
  tagTypes: ['publishEstimates'],
  endpoints: (builder) => ({
    getPublishEstimates: builder.query<PublishEstimates, { published_date: string }>({
      query: (params) => ({ url: '/publish/estimates', method: 'GET', params }),
      providesTags: (_res, _err, arg) => [
        { type: 'publishEstimates', id: 'LIST' },
        { type: 'publishEstimates', id: arg.published_date },
      ],
      transformResponse: (payload) => unwrap<PublishEstimates>(payload),
    }),
    publish: builder.mutation<Response<null>, { published_date: string; send_sms: boolean }>({
      query: (body) => ({ url: '/publish', method: 'POST', body }),
      invalidatesTags: [{ type: 'publishEstimates', id: 'LIST' }],
    }),
  }),
});

export const { useGetPublishEstimatesQuery, usePublishMutation } = publishApi;
